import React, { useEffect, useState, useCallback } from 'react';
import logo from '../../assets/logo.ico'
import Container from '@mui/material/Container';
import { Box, Button, Grid, Typography, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import NavBarHeader from './navbar';
import { getMatGroups } from '../../services/material-services';
import hero from '../../assets/hero.jpg'
import { useAuth } from '../../hooks/useAuth';
import ElementLang from './element-lang';
import config from '../../config-site'


const address_api = config[0].address;
function Header() {
    const { setAuthGroup, authDataGroup, authDataLang } = useAuth();
    const [matGroup, setMatGroup] = useState([]);
    const [imageBackGround, setImageBackGround] = useState(hero);
    const [loading, setLoading] = useState(false);
    const [searchData, setSearchData] = useState('');
    
    const navigate = useNavigate();

    useEffect(() => {
        setLoading(true);
        const getMatGroup = async () => {
            try {
                const data = await getMatGroups(authDataLang?.id, '');
                setMatGroup(data);
                
            } catch (e) {
                console.error(e);
            } finally {
                setLoading(false);
            }
        };

        getMatGroup();
        
        if (authDataGroup) {
            if (authDataGroup?.image?.startsWith(address_api)){
                setImageBackGround(authDataGroup?.image);
            }else{
                setImageBackGround(`${address_api}${authDataGroup?.image}`);
            }

        } else {
            setImageBackGround(hero);
        }

    }, [authDataGroup, authDataLang]);

    const onBackHandler = (value) =>{
        
        setSearchData(value)
    }

    const submitSelectGroup = useCallback((group) => {
        setAuthGroup(group);
        navigate(`/${group.name}`, {
            state: { MatGroup: group, searchData },
            replace: true
        });
    }, [searchData, navigate, setAuthGroup]);

    return (
        <Box
            component="header"
            sx={{
                backgroundImage: `url(${imageBackGround})`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                p: 1,
            }}
            dir={authDataLang?.view_sts ? "rtl" : "ltr"}
        >
            <Container fixed dir={authDataLang?.view_sts ? "rtl" : "ltr"} maxWidth="lg">
                <NavBarHeader materials={matGroup} onBack={onBackHandler}/>
                <Grid container spacing={1}>
                    <Box sx={{ flexGrow: 1, mb: -1  }}>
                        <Grid container spacing={1} justifyContent="center">
                            <Grid item xs={8} sx={{ mt: -1}} >
                                <img src={logo} alt="logo etec" height="70px" weight="48px"/>
                            </Grid>
                            <Grid item xs={4}
                                sx={{
                                    textAlign: authDataLang?.view_sts ? "right" : "left",
                                    marginTop: 2,
                                    marginRight: authDataLang?.view_sts ? 0 : -2,
                                }}>
                                <ElementLang />
                            </Grid>

                            <Grid item xs={10}>
                                <Typography
                                    variant="h3"
                                    component={"h2"}
                                    color="primary.light"
                                    fontFamily='vaziri_light'
                                    sx={{
                                        textAlign: 'center',
                                        marginTop: 3,
                                        marginBottom: 3
                                    }}
                                >
                                    {authDataGroup?.name}
                                </Typography>
                            </Grid>
                        </Grid>
                        <br />
                        <Grid
                            container
                            spacing={1}
                            justifyContent={authDataLang?.view_sts ? "left" : "right"}
                            sx={{ marginBottom: -1 }}
                            >
                            {loading ? (
                                <CircularProgress />
                            ) : (
                                matGroup.map(group => (
                                    <Grid key={group.id} item>
                                        <Button
                                            sx={{ paddingLeft: 1, paddingRight: 1 }}
                                            variant="contained"
                                            color="primary"
                                            onClick={() => submitSelectGroup(group)}
                                        >
                                            <Typography
                                                variant="body2"
                                                component={"h6"}
                                                color="primary.light"
                                                fontFamily='vaziri_medium'
                                            >
                                                {group.name}
                                            </Typography>
                                        </Button>
                                    </Grid>
                                ))
                            )}
                        </Grid>
                        <br />
                    </Box>
                </Grid>
            </Container>
        </Box>
    );
}

export default Header;
